import React from "react";
import { useNavigate } from "react-router-dom";
import "./AdminMenu.css";

const ACCENT_COLORS = [
  "#93c5fd",
  "#a7f3d0",
  "#fde68a",
  "#fca5a5",
  "#c4b5fd",
  "#99f6e4",
  "#f9a8d4",
  "#fdba74",
  "#7dd3fc",
  "#bbf7d0",
  "#fcd34d",
  "#fda4af",
  "#d8b4fe",
  "#6ee7b7",
  "#fbcfe8",
];

// Function to make a hex color darker by a percentage
const darkenHex = (hex, percent) => {
  const num = parseInt(hex.slice(1), 16);
  const amt = Math.round(2.55 * percent);
  const R = Math.max((num >> 16) - amt, 0);
  const G = Math.max(((num >> 8) & 0x00ff) - amt, 0);
  const B = Math.max((num & 0x0000ff) - amt, 0);
  return `#${((R << 16) | (G << 8) | B).toString(16).padStart(6, "0")}`;
};

const AdminMenu = ({ menuItems = [] }) => {
  const navigate = useNavigate();

  return (
    <div className="admin-menu-grid">
      {menuItems.length ? (
        menuItems.map((item, idx) => {
          const base =
            item.accentColor || ACCENT_COLORS[idx % ACCENT_COLORS.length];
          const dark = darkenHex(base, 20); // 20% darker
          return (
            <div
              key={idx}
              className="admin-menu-box"
              role="button"
              tabIndex={0}
              onClick={() => navigate(item.link)}
              onKeyDown={(e) =>
                (e.key === "Enter" || e.key === " ") && navigate(item.link)
              }
              aria-label={item.name}
              style={{
                "--accent": base,
                "--accent-dark": dark,
              }}
            >
              <i className={`fas ${item.icon} admin-menu-icon`} />
              <span className="admin-menu-name">{item.name}</span>
            </div>
          );
        })
      ) : (
        <p className="admin-loading">Loading menu...</p>
      )}
    </div>
  );
};

export default AdminMenu;


//testing